module.exports = __webpack_public_path__ + "assets/img/36-m.ae74908.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/36-m.jpg
// module id = WoOq
// module chunks = 0